import { useEffect, useRef } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { SPA_APP_NAME } from '@atlassian/jira-portfolio-3-common/src/analytics/performance';
import longTaskFactory from '@atlassian/jira-portfolio-3-common/src/long-task';

export const longTask = longTaskFactory(SPA_APP_NAME);

export const useScrollAnalytics = (offset: number) => {
	const lastReportedOffset = useRef<number>(offset);
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		// This check helps defends against firing for implicit scroll events (e.g. page load)
		if (lastReportedOffset.current !== offset) {
			longTask.trackWithTimeout('syncedScrollbar measured', createAnalyticsEvent);
			lastReportedOffset.current = offset;
		}
	}, [createAnalyticsEvent, offset]);
};
